/**
 * Check if likes and super likes need to be loaded
 * @param {number|undefined} likedCount
 * @param {number|undefined} superLikedCount
 * @returns {boolean}
 */
const shouldLoadLikesAndSuperLikesUtil = (likedCount, superLikedCount) =>
  likedCount === undefined && superLikedCount === undefined

export default shouldLoadLikesAndSuperLikesUtil
